/* House of Patakha - behavior layer (no dependencies) */
(function () {
  'use strict';
  if (window.__hopInit) return;
  window.__hopInit = true;

  // paise. Launch discount tiers - shipping itself is free on all prepaid orders.
  var TIER1 = 299900;   // Rs 2,999 -> 10% off
  var TIER2 = 499900;   // Rs 4,999 -> 15% off
  // 30%-off sale styles are excluded from the Launch Offer, so they must not count toward its tiers.
  var SALE_IDS = [8379086635082, 8379086536778, 8379087978570, 8379087781962, 8379087192138, 8379087093834, 8379087028298, 8379086929994, 8379086569546, 8379086831690];
  var RV_KEY = 'hop_recently_viewed';
  var RV_MAX = 12;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatINR(paise) {
    var r = Math.round(paise / 100);
    return 'Rs. ' + r.toLocaleString('en-IN');
  }

  /* ---------- 0b. Move the lone left search icon into the right cluster ---------- */
  function tidyHeaderIcons() {
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    // Dawn renders a search in its own left grid area AND one inside the icon
    // cluster. Keep exactly one, in the cluster, so the top row isn't a lone
    // icon marooned on the left.
    if (window.innerWidth < 990) return;   // mobile: leave Dawn's layout alone
    var stray = document.querySelector('.header > .header__search');
    var inCluster = icons.querySelector('.header__search');
    if (stray) {
      if (inCluster) stray.remove();
      else icons.insertBefore(stray, icons.firstChild);
    }
    // collapse any further duplicates
    var all = icons.querySelectorAll('.header__search');
    for (var i = 1; i < all.length; i++) all[i].remove();
  }

  /* ---------- 1. Nav promo highlight ---------- */
  function navHighlight() {
    var hot = ['/collections/best-sellers', '/collections/ready-to-ship'];
    document.querySelectorAll('.header__menu-item').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (hot.some(function (h) { return href.indexOf(h) !== -1; })) {
        a.classList.add('hop-nav-hot');
      }
    });
  }

  /* ---------- 2. Sticky add-to-cart on product pages ---------- */
  function stickyATC() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var buyBox = document.querySelector('.product-form__buttons');
    if (!form || !buyBox) return;

    var title = (document.querySelector('.product__title h1') || {}).textContent || document.title;
    var img = document.querySelector('.product__media img');
    var priceEl = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');

    var bar = document.createElement('div');
    bar.className = 'hop-satc';
    bar.innerHTML =
      (img ? '<img class="hop-satc__img" src="' + img.src + '" alt="">' : '') +
      '<div class="hop-satc__meta"><p class="hop-satc__title">' + title.trim() + '</p>' +
      '<span class="hop-satc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</span></div>' +
      '<button type="button" class="hop-satc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    bar.querySelector('.hop-satc__btn').addEventListener('click', function () {
      var submit = form.querySelector('[type="submit"], .product-form__submit');
      if (submit) submit.click();
      else form.requestSubmit();
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buyBox);
  }

  /* ---------- 3. Size guide modal ---------- */
  function sizeGuide() {
    var picker = document.querySelector('variant-selects, variant-radios');
    if (!picker) return;
    var legends = picker.querySelectorAll('legend.form__label, .form__label');
    var sizeLegend = null;
    legends.forEach(function (l) {
      if (/size/i.test(l.textContent) && !sizeLegend) sizeLegend = l;
    });
    if (!sizeLegend) return;

    // Body measurements, inches. S-XL grade 2", 2XL+ grade 2" bust/waist with
    // wider hip grading, which is standard for India plus-size womenswear.
    var SIZES = [
      ['S',   '34-35', '27-28', '37-38'],
      ['M',   '36-37', '29-30', '39-40'],
      ['L',   '38-39', '31-32', '41-42'],
      ['XL',  '40-41', '33-34', '43-44'],
      ['2XL', '42-43', '35-36', '45-46'],
      ['3XL', '44-45', '37-38', '47-48'],
      ['4XL', '46-47', '39-41', '49-51'],
      ['5XL', '48-50', '42-44', '52-54'],
      ['6XL', '51-53', '45-47', '55-57']
    ];
    var modal = document.createElement('div');
    modal.className = 'hop-modal';
    modal.innerHTML =
      '<div class="hop-modal__box" role="dialog" aria-label="Size guide">' +
      '<button type="button" class="hop-modal__close" aria-label="Close">&times;</button>' +
      '<h3>Size Guide</h3>' +
      '<p class="hop-sg-intro">Measurements are <strong>body measurements in inches</strong>, not garment measurements. Every style is made in all sizes, S to 6XL.</p>' +
      '<table class="hop-sg-table"><thead><tr><th>Size</th><th>Bust</th><th>Waist</th><th>Hip</th></tr></thead><tbody>' +
      SIZES.map(function (r) {
        return '<tr><td><strong>' + r[0] + '</strong></td><td>' + r[1] + '</td><td>' + r[2] + '</td><td>' + r[3] + '</td></tr>';
      }).join('') +
      '</tbody></table>' +
      '<h4 class="hop-sg-h4">How to measure</h4>' +
      '<ul class="hop-sg-how">' +
      '<li><strong>Bust</strong> &mdash; around the fullest part of your chest, tape level and snug.</li>' +
      '<li><strong>Waist</strong> &mdash; around the narrowest part, usually just above the navel.</li>' +
      '<li><strong>Hip</strong> &mdash; around the fullest part, roughly 8&quot; below the waist.</li>' +
      '</ul>' +
      '<p class="hop-sg-warn"><strong>Please measure before ordering.</strong> Every piece is made to order, so we are unable to offer size exchanges. If you fall between two sizes, we recommend choosing the larger one. Still unsure? WhatsApp us on +91 99134 61515 and we will help you pick.</p>' +
      '</div>';
    document.body.appendChild(modal);

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'hop-sg-link';
    link.textContent = 'Size Guide';
    sizeLegend.appendChild(link);

    link.addEventListener('click', function () { modal.classList.add('is-open'); });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('hop-modal__close')) {
        modal.classList.remove('is-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.classList.remove('is-open');
    });
  }

  /* ---------- 4. Free shipping progress bar (cart drawer + cart page) ---------- */
  function shipBarHTML(total, hasSale) {
    // Shipping is free on every order, so the bar tracks the Launch Offer tiers.
    // total = only the items the Launch Offer applies to (sale styles excluded).
    var msg, pct;
    if (hasSale && total === 0) {
      msg = '&#127881; <strong>Sale price applied</strong> &mdash; already 30% off.';
      pct = 100;
    } else if (total < TIER1) {
      msg = 'Add <strong>' + formatINR(TIER1 - total) + '</strong> more of non-sale styles for <strong>10% OFF</strong>';
      pct = Math.round(total / TIER1 * 100);
    } else if (total < TIER2) {
      msg = '&#127881; <strong>10% OFF</strong> unlocked. Add <strong>'
          + formatINR(TIER2 - total) + '</strong> more for <strong>15% OFF</strong>';
      pct = Math.round(total / TIER2 * 100);
    } else {
     pct = 100;
    }
    if (hasSale && total > 0) msg += '<br><span class="hop-ship__note">Launch Offer applies to non-sale styles; sale styles are already 30% off.</span>';
    msg += '<br><span class="hop-ship__note">Free shipping on every order. Pay online for 5% extra off.</span>';
    return '<div>' + msg + '</div><div class="hop-ship__bar"><div class="hop-ship__fill" style="width:'
        + Math.min(100, pct) + '%"></div></div>';
  }

  function refreshShipBar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hosts = document.querySelectorAll('.drawer__inner .drawer__header, .cart__warnings, cart-items');
        var target = document.querySelector('.drawer__inner') || document.querySelector('#main-cart-items');
        if (!target) return;
        var bar = document.querySelector('.hop-ship');
        if (cart.item_count === 0) { if (bar) bar.remove(); return; }
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'hop-ship';
          target.insertBefore(bar, target.firstChild);
        }
        var eligible = 0, hasSale = false;
        cart.items.forEach(function (it) {
          if (SALE_IDS.indexOf(it.product_id) !== -1) hasSale = true;
          else eligible += it.original_line_price;
        });
        bar.innerHTML = shipBarHTML(eligible, hasSale);
      })
      .catch(function () {});
  }

  function watchCart() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refreshShipBar, 400); });
      }
      return p;
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble')) setTimeout(refreshShipBar, 350);
    });
    refreshShipBar();
  }

  /* ---------- 5. Recently viewed ---------- */
  function recentlyViewed() {
    var host = document.querySelector('[data-hop-rv]');
    var currentHandle = host ? host.getAttribute('data-hop-rv-current') : null;

    // record current product
    if (currentHandle) {
      try {
        var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
        list = list.filter(function (h) { return h !== currentHandle; });
        list.unshift(currentHandle);
        localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX)));
      } catch (e) {}
    }
    if (!host) return;

    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    handles = handles.filter(function (h) { return h !== currentHandle; }).slice(0, 4);
    if (!handles.length) { var sec = host.closest('.shopify-section'); if (sec) sec.style.display = 'none'; return; }

    var grid = host.querySelector('.hop-rv__grid');
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var a = document.createElement('a');
          a.className = 'hop-rv__card';
          a.href = '/products/' + p.handle;
          var img = (p.images && p.images[0]) ? p.images[0] + '&width=400' : '';
          if (img.indexOf('?') === -1) img = img.replace('&width=400', '?width=400');
          a.innerHTML =
            (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') +
            '<p class="hop-rv__title">' + p.title + '</p>' +
            '<span class="hop-rv__price">' + formatINR(p.price) + '</span>';
          grid.appendChild(a);
        })
        .catch(function () {});
    });
  }

  /* ---------- 5b. Wishlist (localStorage, no app) ---------- */
  var WL_KEY = 'hop_wishlist';
  var HEART_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 21s-7.6-4.9-10.1-9.2C.2 8.6 2.3 5 5.9 5c2.1 0 3.5 1.1 4.1 2.3h4C14.6 6.1 16 5 18.1 5c3.6 0 5.7 3.6 4 6.8C19.6 16.1 12 21 12 21z"/></svg>';

  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function wlSet(l) { try { localStorage.setItem(WL_KEY, JSON.stringify(l)); } catch (e) {} wlBadge(); }
  function wlHas(h) { return wlGet().indexOf(h) !== -1; }
  function wlToggle(h) {
    var l = wlGet(); var i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    wlSet(l); return i === -1;
  }
  function handleFromUrl(u) {
    var m = (u || '').match(/\/products\/([a-z0-9\-]+)/i);
    return m ? m[1] : null;
  }

  function wlBadge() {
    var a = document.querySelector('.hop-wl-link');
    if (!a) return;
    var n = wlGet().length;
    var c = a.querySelector('.hop-wl-count');
    if (c) c.textContent = n;
    a.classList.toggle('has-items', n > 0);
  }

  function wlHeader() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.hop-wl-link')) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header__icon hop-wl-link';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = HEART_SVG + '<span class="hop-wl-count">0</span>';
    icons.insertBefore(a, icons.firstChild);
    wlBadge();
  }

  function wlCards() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.hop-wl-card-btn')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link ? handleFromUrl(link.getAttribute('href')) : null;
      if (!h) return;
      var media = card.querySelector('.card__media, .card__inner') || card;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hop-wl-card-btn' + (wlHas(h) ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = HEART_SVG;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        btn.classList.toggle('is-active', wlToggle(h));
      });
      media.style.position = 'relative';
      media.appendChild(btn);
    });
  }

  function wlProductPage() {
    var h = handleFromUrl(location.pathname);
    var buyBox = document.querySelector('.product-form__buttons');
    if (!h || !buyBox || document.querySelector('.hop-wl-pdp')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hop-wl-pdp' + (wlHas(h) ? ' is-active' : '');
    btn.innerHTML = HEART_SVG + '<span>' + (wlHas(h) ? 'Saved to wishlist' : 'Add to wishlist') + '</span>';
    btn.addEventListener('click', function () {
      var added = wlToggle(h);
      btn.classList.toggle('is-active', added);
      btn.querySelector('span').textContent = added ? 'Saved to wishlist' : 'Add to wishlist';
    });
    buyBox.parentNode.insertBefore(btn, buyBox.nextSibling);
  }

  function wlPage() {
    var host = document.querySelector('[data-hop-wl]');
    if (!host) return;
    var grid = host.querySelector('.hop-rv__grid');
    var handles = wlGet();
    if (!handles.length) {
      host.innerHTML = '<div class="hop-wl-empty"><h2 class="h2">Your wishlist is empty</h2><p>Tap the heart on any product to save it here.</p><a class="button" href="/collections/best-sellers">Shop Best Sellers</a></div>';
      return;
    }
    handles.forEach(function (h) {
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var wrap = document.createElement('div');
          wrap.className = 'hop-wl-grid-card';
          var img = (p.images && p.images[0]) ? p.images[0] : '';
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=400';
          wrap.innerHTML =
            '<a class="hop-rv__card" href="/products/' + p.handle + '">' +
            (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') +
            '<p class="hop-rv__title">' + p.title + '</p>' +
            '<span class="hop-rv__price">' + formatINR(p.price) + '</span></a>' +
            '<button type="button" class="hop-wl-remove" aria-label="Remove">&times;</button>';
          wrap.querySelector('.hop-wl-remove').addEventListener('click', function () {
            wlToggle(p.handle); wrap.remove();
            if (!wlGet().length) wlPage();
          });
          grid.appendChild(wrap);
        })
        .catch(function () {});
    });
  }

  /* ---------- 6. UGC carousel arrows ---------- */
  function ugcNav() {
    document.querySelectorAll('.hop-ugc').forEach(function (root) {
      var track = root.querySelector('.hop-ugc__track');
      if (!track) return;
      root.querySelectorAll('.hop-ugc__nav').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.classList.contains('hop-ugc__nav--next') ? 1 : -1;
          track.scrollBy({ left: dir * (track.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- 0. Relocate product detail accordions into buy column ---------- */
  function relocateProductDetails() {
    var pd = document.querySelector('[data-hop-pd]');
    var container = document.querySelector('.product__info-container');
    if (pd && container) {
      var sectionShell = pd.closest('.shopify-section');
      if (sectionShell && sectionShell.contains(container)) return; // already moved
      var desc = container.querySelector('.product__description');
      if (desc && desc.parentNode === container) container.insertBefore(pd, desc.nextSibling);
      else container.appendChild(pd);
      if (sectionShell) sectionShell.style.display = 'none';
    }
  }

  /* ---------- Empty collection tidy-up ---------- */
  function tidyEmptyCollection() {
    var empty = document.querySelector('.collection--empty');
    if (!empty) return;
    // With a filter applied, "use fewer filters" is the right advice. On a
    // not-yet-stocked category the collection description already explains it,
    // and Dawn's message on top just reads like something broke.
    if (location.search.indexOf('filter.') !== -1) return;
    var msg = empty.querySelector('.title-wrapper, .title-wrapper-with-link');
    if (msg) msg.style.display = 'none';
  }

  /* ---------- Ready to Ship / Made to Order badge ---------- */
  function stockBadge() {
    var el = document.querySelector('[data-hop-badge]');
    var data = document.querySelector('[data-hop-stock]');
    if (!el || !data) return;
    var qty;
    try { qty = JSON.parse(data.textContent); } catch (e) { return; }

    // relocateProductDetails() drops the whole block below the description;
    // the availability badge belongs next to the price where it informs the buy.
    var price = document.querySelector('.product__info-container .price');
    if (price && price.parentNode && !el.dataset.hopMoved) {
      el.dataset.hopMoved = '1';
      var tax = document.querySelector('.product__info-container .product__tax');
      var anchor = tax || price;
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }

    // Shopify would normally land on selected_or_first_available_variant, but
    // continue-selling makes every variant "available", so it always lands on the
    // first size - which since the M-to-XXL fill-in is usually a 0-stock,
    // made-to-order one. Preselect the first size that is actually in stock so a
    // shopper sees the 2-3 day option when one exists. Only on a clean load; a
    // ?variant= link is an explicit choice and is left alone.
    function preselectInStock() {
      if (location.search.indexOf('variant=') !== -1) return;
      var current = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (current && qty[current.value] > 0) return;
      var best = null;
      for (var id in qty) { if (qty[id] > 0) { best = id; break; } }
      if (!best) return;
      var meta = document.querySelector('[data-hop-variants]');
      if (!meta) return;
      var variants;
      try { variants = JSON.parse(meta.textContent); } catch (e) { return; }
      var match = variants.filter(function (v) { return String(v.id) === String(best); })[0];
      if (!match) return;
      match.options.forEach(function (val) {
        var radio = document.querySelector(
          '.product-form__input input[type="radio"][value="' + CSS.escape(val) + '"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        var sel = document.querySelector('.product-form__input select');
        if (sel && sel.value !== val) {
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === val) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      });
    }

    function currentId() {
      // The hidden cart input is what actually gets submitted and Dawn updates it
      // synchronously, whereas ?variant= is rewritten a beat later - reading the
      // URL first left the badge showing the previous variant's dispatch time.
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value && input.value in qty) return input.value;
      var u = new URLSearchParams(location.search).get('variant');
      return (u && u in qty) ? u : null;
    }

    function paint() {
      var id = currentId();
      if (!id) return;
      var inStock = qty[id] > 0;
      el.classList.toggle('is-ready', inStock);
      el.classList.toggle('is-mto', !inStock);
      el.innerHTML = '<span class="hop-pd__dot"></span>' + (inStock
        ? 'Ready to Ship · Dispatch in 2–3 days'
        : 'Made to Order · Dispatch in 10–15 days');
    }
    paint();
    // Dawn swaps the variant without a page load, so watch the picker itself.
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(paint, 60);
      }
    });
    window.addEventListener('popstate', paint);

    // After the listeners exist, so the resulting change repaints the badge.
    // Dawn settles the form/URL asynchronously and the exact timing varies, so
    // repaint a few times rather than betting on one delay.
    preselectInStock();
    [80, 300, 800].forEach(function (d) { setTimeout(paint, d); });
  }

  ready(function () {
    relocateProductDetails();
    stockBadge();
    tidyEmptyCollection();
    tidyHeaderIcons();
    navHighlight();
    stickyATC();
    sizeGuide();
    recentlyViewed();
    ugcNav();
    wlHeader();
    wlCards();
    wlProductPage();
    wlPage();
    // Re-scan cards added by sliders / quick-add. Debounced: the observer fires
    // on our own insertions too, so an unthrottled handler re-queries every
    // card on each mutation.
    var wlTimer = null;
    var mo = new MutationObserver(function () {
      if (wlTimer) return;
      wlTimer = setTimeout(function () { wlTimer = null; wlCards(); }, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
